var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.vm.isMobile)?_c('SuperTouchMobile'):(_vm.lang == 'zh')?_c('SuperTouchPcZh'):_c('SuperTouchPc')}
var staticRenderFns = []

export { render, staticRenderFns }